import { useEffect, useState } from 'react';
// TODO: check if this file should be whole in ui - 82948
import { Button } from 'ui/button';

export const useTextCollapseExpand = ({
  buttonTitles = { less: 'Show less', more: 'Show more' },
  rows = 2,
  text,
}: {
  buttonTitles?: { less: string; more: string };
  rows?: number;
  text?: string;
}) => {
  const [isDescriptionShrunk, setIsDescriptionShrunk] = useState(true);
  const [isEllipsisApplied, setIsEllipsisApplied] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Valid usage of effect
    setIsEllipsisApplied(false);
    setIsDescriptionShrunk(true);
  }, [text]);

  const button = isEllipsisApplied ? (
    <Button
      onClick={() => {
        setIsDescriptionShrunk((isPreviousDescriptionShrunk) => !isPreviousDescriptionShrunk);
      }}
      type="link-primary"
    >
      {isDescriptionShrunk ? buttonTitles.more : buttonTitles.less}
    </Button>
  ) : null;

  return {
    collapseExpandButton: button,
    ellipsis: isDescriptionShrunk
      ? {
          onEllipsis() {
            setIsEllipsisApplied(true);
          },
          rows,
        }
      : false,
  };
};
